module.exports = "pegasus/assets/hexline-snapchat.png";